export default "__VITE_ASSET__wjpQPCjM__"